import {
  serverDriveSharingLink, serverDriveLink, serverDriveTexts,
} from '../serverInject';
import { updateDriveTexts } from '../texts/index';
import webapiURL from './webapiurl';

export const driveMSInfoJSURL = (needsFileInfo) => {
  const params = {
    api: 'SYNO.SynologyDrive.Shard',
    version: 1,
    method: 'getjs',
    mobile_only_info: !needsFileInfo,
    sharing_type: 'file_request',
    permanent_link: `"${serverDriveLink()}"`,
  }

  const sharingLink = serverDriveSharingLink()

  if (sharingLink) {
    params.sharing_link = sharingLink
  }

  return webapiURL(params)
}

export const insertDriveMSInfoScript = () => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.setAttribute('src', driveMSInfoJSURL(true))

  script.onload = resolve
  script.onerror = reject

  document.head.appendChild(script)
})

export const insertDriveMSTextsScript = () => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.setAttribute('src', driveMSInfoJSURL(false))

  script.onload = () => {
    updateDriveTexts(serverDriveTexts())
    resolve()
  }
  script.onerror = reject

  document.head.appendChild(script)
})

export const reloadWithoutRouting = () => {
  // eslint-disable-next-line prefer-destructuring
  window.location.href = window.location.href.split('#')[0]
}
